import { FhsAxios } from "../../services/axios";

export default {
  state: {
    rate: {
      USD: null,
      EUR: null,
      RUB: null,
      KZT: null
    }
  },
  actions: {
    fetchCurrencyRate({ commit, _ }) {
      commit("setCurrencyRate", null);
      FhsAxios.get("user/currency-rate", {
        data: {}
      }).then(response => {
        commit("setCurrencyRate", response.data.result["currency-rate"]);
      });
    }
  },
  mutations: {
    setCurrencyRate(state, rate) {
      state.rate = rate;
    }
  },
  getters: {
    rate(state) {
      return state.rate;
    }
  }
};
